module.exports = __webpack_public_path__ + "img/bg-info.67e2959f.png";